import React from 'react'
import { Card, Image } from 'semantic-ui-react';
import Labels from './../../../../../common/Labels';
import EllipsisTooltip from './../../../../../common/EllipsisTooltip';
import ActivityUserInfo from './../ActivityUserInfo';
import { Grid } from 'semantic-ui-react';
import { history } from '../../../../../../helpers';
import { dispatch } from '@rematch/core';
import noImage from '../../../../../../images/common/broken-image.png'
import EventDetailsNotFound from '../../Modal/EventDetailsNotFound';
class PlaybookCard extends React.Component {
    async goToPlaybook(id, selectedPlaybook, data) {
        if(selectedPlaybook.status === -1) {
            return false;   
        }
        if (this.props.data && this.props.data.entityId) {
            await dispatch.lifeCycle.isPlaybookAvailable(this.props.data.entityId);
        }
        if (this.isAuthor() || this.isDesigner()) {
            selectedPlaybook._id = id;
            await dispatch.home.redirectFromEventStream(true);
            await dispatch.lifeCycle.isPlaybookAvailable(id);
            if (!this.props.noEventDataFound) {
                dispatch.lifeCycle.setInitState(selectedPlaybook.status)
                dispatch.createPack.setSelectedActivityData({})
                dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(id);
                dispatch.lifeCycle.isPlaybookImportLoading(false);
                dispatch.lifeCycle.setSelectedPracticeLibrary(selectedPlaybook);
                dispatch.lifeCycle.getInviteByPackIdAsync(id);

                dispatch.lifeCycle.setArrangementPaneFlag(true);
                dispatch.lifeCycle.modalEditOpen(true);
                dispatch.lifeCycle.updateEditCardImageAsync(null);

                dispatch.lifeCycle.setParticipantsAsync([]);
                dispatch.lifeCycle.setInvitedParticipantAsync([]);
                dispatch.lifeCycle.setIdToCenterPosition(id);
                dispatch.lifeCycle.splitAt("60%");
                dispatch.lifeCycle.activePage('libraryCard');
                dispatch.lifeCycle.setPlaybookError(null);
                //this.props.setCollapsedResourcePaneIndex(null);
                dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                switch (selectedPlaybook.status) {
                    case 0:
                        return dispatch.lifeCycle.showResourecePane("Indesign");
                    case 1:
                        return dispatch.lifeCycle.showResourecePane("Indesign");
                    case 2:
                        return dispatch.lifeCycle.showResourecePane("Indesign");
                    case 4:
                        return dispatch.lifeCycle.showResourecePane("PublishedPack");
                    case 5:
                        return dispatch.lifeCycle.showResourecePane("PublishedPack");
                    default:
                        return null;
                }
            }
        }
        else {
            return false;
        }



    }

    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    isAuthor = () => {

        let authors = this.props.currentOrganization && this.props.currentOrganization && this.props.user &&
            this.props.currentOrganization.users &&
            this.props.currentOrganization.users.filter(el => el.accountUserId === this.props.user._id &&
                el.role === "workspaceOwner");

        if (authors && authors.length > 0) {
            return true;
        }
        return null;
    }
    isDesigner = () => {
        const loggdinUserId = this.props.user && this.props.user._id;
        let author =
            this.props.singlePlaybookEntry &&
            this.props.singlePlaybookEntry.participants &&
            this.props.singlePlaybookEntry.participants.filter(
                (participant) => {
                    return participant.role === "author";
                }
            );
        if (author && author.length > 0) {
            return author.find((author) => author.accountUserId === loggdinUserId);
        }
        return null;
    }

    render() {
        const { data, selectedOrganisation, selectedAccount, currentOrganization } = this.props
        return (
            <div className="StreamActivity" >
                {data.from ?
                    <ActivityUserInfo
                        user={data.from}
                        date={data.createdAt}
                        subCategory={data.subCategory}
                        data={data}
                        selectedAccount={selectedAccount}
                        selectedOrganisation={selectedOrganisation}

                    /> : ''}
                <div className="ActivityStreamContent"  >
                    <div className="streamCard"
                        onClick={() => this.goToPlaybook(data.entityId, data.entityData)}
                    >
                        <div className="imageBlock">
                            <Card className="appDefaultCard">
                                <Card.Header>
                                    <EllipsisTooltip
                                        name={data.entityData.name}
                                    />
                                </Card.Header>
                                <Card.Content >
                                    <Image onError={this.addDefaultSrc} className="fitImage" src={data.entityData.picture} />

                                    {data.entityData.status === 0 ?
                                        <div className="badge badgeIndesign">In Design </div>
                                        : data.entityData.status === 1 ? <div className="badge badgeInReview">Review request </div>
                                            : data.entityData.status === 2 ? <div className="badge badgeApproved">Approved </div>
                                                : data.entityData.status === 3 ? <div className="badge badgeRejected">Rejected </div>
                                                    : data.entityData.status === 4 ? <div className="badge badgePublished">Published </div>
                                                        : data.entityData.status === 5 ? <div className="badge badgeDepricated">Inactive </div>
                                                            : data.entityData.status === 6 ? <div className="badge badgeCloned">Cloned / Purchased </div>
                                                              : data.entityData.status === -1 ? <div className="badge badgeCloned">Generating </div>
                                                                : ''}

                                    <div className="badgeRight">
                                        <span className={`badgeblock ${data.entityData.scope === 'Public' ? 'badgeRightPublic' : ''} ${data.entityData.scope === 'Private' ? 'badgeRightPrivate' : ''}`}>
                                            {data.entityData.scope === "Private" ? "Workspace" : data.entityData.scope}
                                        </span>
                                    </div>
                                </Card.Content>
                            </Card>
                        </div>
                        <div className="contentBlock">
                            <Grid columns='equal'>

                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels
                                            name="Knowledge bank"
                                            text={<EllipsisTooltip name={data.entityData.baseCategory} />} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Labels
                                            name="Category"
                                            text={<EllipsisTooltip name={data.entityData.category} />} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Labels
                                            name="Sub Category "
                                            text={<EllipsisTooltip name={data.entityData.subCategory} />} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels name="Description"
                                            text={<EllipsisTooltip name={data.entityData.description}
                                                line={4}
                                                position="right center"
                                                ReadMore={true}
                                                htmlView={true}
                                                stripHtml={true}
                                            />}
                                        />
                                    </Grid.Column>

                                </Grid.Row>
                            </Grid>
                            <EventDetailsNotFound
                                open={this.props.noEventDataFound}
                            />
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default PlaybookCard;